import { useState, useEffect } from 'react'
import { Link, Image, fetchSync } from "@shopify/hydrogen";
import { makeKey } from "../../utilities/helpers";
import { Suspense } from "react";


export default function ProductRecipes({ content, links, product  }) {
  const { headline, description, image, ctaLink, ctaLabel, navHeadline } = content

  return (
    <section className="py-12 bg-forest">
      <div className="border-y-2 border-gold">
        <div className="container max-w-screen-xl !py-20 mx-auto grid grid-cols-1 md:grid-cols-6 lg:grid-cols-7 gap-16">
          <div className="flex flex-col gap-6 py-16 md:col-span-3 lg:order-2 lg:col-span-2">
            <h2 className="font-sans uppercase !text-gold">{headline}</h2>
            <p>{description}</p>
            {ctaLink &&
              <Link to={ctaLink} className="mx-0 mb-0 btn btn-action">{ctaLabel}</Link>
            }
          </div>
          <div className="md:col-span-3 lg:col-span-3 lg:order-3 print-hidden">
            {image &&
              <Image src={image} width={460} height={555} className="object-cover mx-auto aspect-4/5 rounded-jumbo" alt={headline} />
            }
          </div>
          <div className="py-16 md:col-span-6 lg:order-1 lg:col-span-2">
            <dl className="grid gap-8">
              <dt className="h3 text-gold">{navHeadline}</dt>
              <Suspense>
                <RecipeApi product={product} />
              </Suspense>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}

function RecipeApi({ product }) {
  const recipes = fetchSync('https://api.bittercube.com/api/recipes.json').json()
  const [suggestedRecipes, setSuggestedRecipes] = useState([])
  useEffect(() => {
    if (!recipes.length || !product?.title) return

    const getProductRecipes = () => {
      // Find all recipes that contain the product
      const productRecipes = recipes.filter(recipe => 
        recipe.make_the_cocktail.ingredients?.some(ingredient => 
          ingredient.name.toLowerCase().includes(product.title.toLowerCase())
        )
      )
      
      if (productRecipes.length > 0) {
        setSuggestedRecipes(productRecipes)
        // If we have product-specific recipes
      if (productRecipes.length > 0) {
        // If we have 4 or fewer product recipes, use all of them
        if (productRecipes.length <= 4) {
          setSuggestedRecipes(productRecipes)
          return
        }

        // If we have more than 4, randomly select 4
        const selectedRecipes = []
        const usedIndices = new Set()

        while (selectedRecipes.length < 4) {
          const randomIndex = Math.floor(Math.random() * productRecipes.length)
          if (!usedIndices.has(randomIndex)) {
            usedIndices.add(randomIndex)
            selectedRecipes.push(productRecipes[randomIndex])
          }
        }

        setSuggestedRecipes(selectedRecipes)
      }
      }else{
        // // If no product-specific recipes found, get 4 random recipes
        const randomRecipes = []
        const usedIndices = new Set()

        while (randomRecipes.length < 4) {
          const randomIndex = Math.floor(Math.random() * recipes.length)
          if (!usedIndices.has(randomIndex)) {
            usedIndices.add(randomIndex)
            randomRecipes.push(recipes[randomIndex])
          }
        }
        setSuggestedRecipes(randomRecipes)
      }
    }

    getProductRecipes()
  }, [])

  return (
    <>
    {suggestedRecipes && suggestedRecipes.map((recipe, i) => (
      <dd key={makeKey(recipe.name)}>
        <span className="font-bold tracking-wide text-gold">0{i + 1}</span>
        <hr className="my-2 border-t-2 text-gold" />
        <Link to={`/recipes/${recipe.slug}`} className="flex items-center justify-between w-full gap-2 mx-auto label group">{recipe.name} <div className="btn-arrow btn-arrow-gold"></div></Link>
      </dd>
    ))}
    </>
  )
}